import React from "react";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

interface ParentsProps {
  query: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function ExerciseSearchingBar({query,onChange}:ParentsProps) {

  return (
    <Search sx={{ display: "flex",width:"100%" }}>
      <Paper
      variant="outlined"
        component="form"
        sx={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <SearchIconWrapper >
          <SearchIcon sx={{width:"100%"}} />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search for an exercise..."
          inputProps={{ "aria-label": "search" }}
          sx={{ width:"100%" }}
          type="search"
          onChange={onChange}
          fullWidth
          value={query}
        />{" "}
      </Paper>
    </Search>
  );
}

export default ExerciseSearchingBar;
